import { useState } from "react";
import { useParams } from "react-router-dom";
import Template from "../../components/template";
import Report from "./components/Report";
import PaymentInformation from "./components/PaymentInformation";
import History from "./components/History";
import Statistics from "../../financial/components/Statistics";
import Jobs from "./components/Jobs";

const Valuation = () => {
    const { ftm_id } = useParams();
    const [refreshKey, setRefreshKey] = useState(0);
    const [valuationId, setValuationId] = useState(0);

    const triggerRefresh = () => {
        setRefreshKey(prev => prev + 1);
    };

    return (
        <Template>
            <div className="container-fluid my-3 py-3">
                <Statistics
                    selectedFtm={{value: ftm_id}}
                    dataFilter={null}
                />
                <div className="row mb-5">
                    <div className="col-lg-7 col-md-7">
                        <PaymentInformation
                            ftm_id={ftm_id}
                            onRefresh={triggerRefresh}
                        />

                        <History
                            ftm_id={ftm_id}
                            refreshKey={refreshKey}
                            valuationId={valuationId}
                            setValuationId={setValuationId}
                        />
                    </div>

                    <div className="col-lg-5 col-md-5">
                        <Report
                            ftm_id={ftm_id}
                            refreshKey={refreshKey}
                            valuationId={valuationId}
                        />
                    </div>
                </div>

                <Jobs ftm_id={ftm_id} refreshKey={refreshKey}/>
            </div>
        </Template>
    );
};

export default Valuation;